@use '../../../styles/tokens' as *;

.placeholder {
  color: $colorGray;
}

.grayscale {
  filter: grayscale(100%);
}
